import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {fesPortalUrl} from '../../config';

const CheckIcon = () => (
    <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M5 13l4 4L19 7"
        />
    </svg>
);

const SuccessPage = () => {
    const navigate = useNavigate();
    const initKey = localStorage.getItem('requestInit');
    useEffect(() => {
        if (!initKey) {
            navigate('/publicdemo', { replace: true });
        }
    }, []);
    const handleExit = () => {
        // const initKey = localStorage.getItem('requestInit');
        // if (initKey === 'mock-request') {
        //     navigate('/dashboard/documents', { replace: true });
        // }  else {
        //     navigate('/publicdemo', { replace: true });
        // }
        window.location.href = fesPortalUrl;
        localStorage.removeItem('requestInit');
    };

    if (!initKey)return <div></div>;

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
            <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="bg-blue-600 px-6 py-8 text-center">
                    <h1 className="text-3xl font-bold text-white">
                        Success! Your BioConsent Verification is Complete
                    </h1>
                </div>

                <div className="px-6 py-8">
                    {/* <p className="text-gray-700 text-lg mb-6 text-center">
                        Thank you. You've successfully completed a biometric KYC process powered by faceEsign BioConsent.
                    </p> */}

                    <div className="bg-blue-50 rounded-lg p-6 mb-6">
                        <p className="text-blue-800 font-semibold mb-4">
                            💡 With faceEsign BioConsent, your platform can:
                        </p>
                        <ul className="space-y-3">
                            {[
                                'Detect and block AI/deepfakes using advanced liveness checks',
                                'Capture intelligent video + audio consent for legal and audit trails',
                                'Generate tamper-proof, biometric verified evidence via facial recognition',
                                'Stay compliant: UCC Article 12 (CERs), FinCEN, ESIGN ACT, GDPR'
                            ].map((text, index) => (
                                <li key={index} className="flex items-start">
                                    <CheckIcon />
                                    <span className="text-gray-700">{text}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="text-gray-600 text-center italic mb-8">
                        This demo shows how fun, fast, and easy it is to use and integrate our patented BioConsent technology. Real-time use is even faster — and we can help embed it into your platform in just a few hours. 
                    </p>

                    <div className="flex justify-center">
                        <button
                            onClick={handleExit}
                            className="px-8 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
                        >
                            EXIT
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuccessPage;